/**
 * Build LMS course id list from campaign template preview API shape.
 * Supports: template.courseId alone, template.courses[].courseId, and id/course_id fallbacks.
 */
export function collectTemplateCourseIds(template) {
	if (!template) return [];
	const ids = [];
	const seen = new Set();
	const add = (v) => {
		if (v == null || v === "") return;
		const key = String(v);
		if (seen.has(key)) return;
		seen.add(key);
		ids.push(v);
	};
	if (Array.isArray(template.courses)) {
		for (let i = 0; i < template.courses.length; i++) {
			const row = template.courses[i];
			if (!row || typeof row !== "object") continue;
			const id = row.courseId != null ? row.courseId : row.id != null ? row.id : row.course_id;
			add(id);
		}
	}
	const primary = template.courseId != null ? template.courseId : template.course_id;
	add(primary);
	return ids;
}
